module.exports = __webpack_public_path__ + "img/leumi.f6474ebe.svg";